import React, {useEffect} from "react";
import { ListGroupItem, Button } from "reactstrap";

const FileItem = ({
                      file,
                      onNavigate,
                      onDelete,
                      onRename,
                      onDownload,
                      onShare,
                      onUnshare,
                      refresh,
                  }) => {
    const handleRename = () => {
        const newName = prompt("Enter new name", file.name);
        if (newName) onRename(file.id, newName).then(refresh);
    };

    const handleDelete = () => {
        if (window.confirm("Delete?")) onDelete(file.id).then(refresh);
    };

    const handleShare = () => {
        const email = prompt("Share with (email)?");
        if (email) onShare(file.id, email).then(refresh);
    };

    const handleUnshare = () => {
        const email = prompt("Unshare from (email)?");
        if (email) onUnshare(file.id, email).then(refresh);
    };

    useEffect(() => {
        console.log(file)
        return () => {
            
        }
    }, []);


    return (
        <ListGroupItem className="d-flex justify-content-between align-items-center">
      <span onClick={() => {
          console.log("clicked")
          onNavigate(file)
      }} style={{ cursor: file?.isFolder ? "pointer" : "default" }}>
        📁 {file.name}
      </span>
            <div>
                {!file.isFolder && (
                    <>
                        <Button size="sm" onClick={() => onDownload(file.id)}>⬇ </Button>{" "}
                    </>
                )}
                <Button size="sm" onClick={handleRename}>✏️ </Button>{" "}
                <Button size="sm" onClick={handleDelete}>🗑️ </Button>{" "}
                <Button size="sm" onClick={handleShare}>📤 </Button>{" "}
                <Button size="sm" onClick={handleUnshare}>🚫 </Button>
            </div>
        </ListGroupItem>
    );
};

export default FileItem;
